import React, { Component } from 'react'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'

import { phaseChange, reroute, storeDumpItForce } from '../../../actions/Buy'

class BonificoReadyForDocs extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.handleOnClick = this.handleOnClick.bind(this)
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register', true)
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // eslint-disable-next-line
    for (const key in nextState) {
      if (nextState[key] !== this.state[key]) {
        return true
      }
    }
    // eslint-disable-next-line
    for (const key in nextProps) {
      if (nextProps[key] !== this.props[key]) {
        return true
      }
    }
    return false
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 45 })
    if (!this.state.toTop) {
      animateScroll.scrollToTop()
      this.setState({ toTop: true })
    }
    this.props.storeDumpItForce()
  }

  handleOnClick() {
    if (!this.props.fetching) {
      this.props.phaseChange({
        last: this.props.ui.last > 45 ? this.props.ui.last : 45,
      })
      this.props.reroute('/documents', true)
    }
  }

  render() {
    const settings = function (uri) {
      return () =>
        window.open(
          uri,
          '',
          'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'
        )
    }

    return (
      <div className={'thank-you'}>
        <div className={'thank-you__content'}>
          <div className="thank-you__top">
            <h1 className={'thank-you--title'}>
              Grazie, {this.props.customer.nome}!
            </h1>
            <p className={'thank-you--intro'}>
              La tua auto brumbrum ti aspetta!
              <br />
              Mancano solo i tuoi documenti per salire a bordo della tua{' '}
              {this.props.product.marca} {this.props.product.modello}{' '}
              {this.props.product.auto_id}.
            </p>
          </div>
          <div className="thank-you__button">
            <button
              className={`btn btn-primary thank-you--btn${
                this.props.fetching ? ' btn-disabled' : ''
              }`}
              data-cy="read-for-docs-submit"
              onClick={this.handleOnClick}
            >
              <span>Carica i tuoi documenti!</span>
            </button>
          </div>
          <div className={'thank-you__socials'}>
            <div className="share-friends">
              <h4>Condividi questa gioia con i tuoi amici!</h4>
              <ul className="social_list">
                <li>
                  <span
                    className={'facebook social_icon'}
                    onClick={settings(`https://www.facebook.com/brumbrum.it`)}
                    title="Condividi su Facebook"
                  >
                    <i className={'icon-facebook'} />
                  </span>
                </li>
                <li>
                  <span
                    className={'twitter social_icon'}
                    onClick={settings(`https://twitter.com/brumbrumSpA`)}
                    title="Condividi su Twitter"
                  >
                    <i className={'icon-twitter'} />
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  product: state.product,
  customer: state.customer,
  fetching: state.ui.fetching,
  ui: state.ui,
})

export default connect(mapStateToProps, {
  reroute,
  storeDumpItForce,
  phaseChange,
})(BonificoReadyForDocs)
